import React from 'react';
import SaveIcon from "@mui/icons-material/Save";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function EventInfo({
  isOpen,
  onToggle,
  tempNbpers,
  setTempNbpers,
  tempLieu,
  setTempLieu,
  tempDateEvent,
  setTempDateEvent,
  tempTypeBar,
  setTempTypeBar,
  tempMore,
  setTempMore,
  hasChanges,
  onSave
}) {
  return (
    <>
      <div className="accordion-header" onClick={onToggle}>
        <span className="accordion-title">
          <i className="pi pi-calendar"></i> Détails Événement
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {hasChanges && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                onSave();
              }}
              style={{
                borderRadius: "4px",
                color: "#fff",
                width: "22px",
                height: "22px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "#322915",
              }}
            >
              <SaveIcon sx={{ fontSize: 13 }} />
            </span>
          )}
          {isOpen ? (
            <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
          ) : (
            <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
          )}
        </div>
      </div>

      {isOpen && (
        <>
          <div className="grid mb-2">
            <div className="col-12 md:col-3">
              <label className="field-label">Nb personnes</label>
              <input
                type="number"
                className="clean-input"
                value={tempNbpers}
                onChange={(e) => setTempNbpers(e.target.value)}
              />
            </div>
            <div className="col-12 md:col-3">
              <label className="field-label">Lieu</label>
              <input
                className="clean-input"
                value={tempLieu}
                onChange={(e) => setTempLieu(e.target.value)}
              />
            </div>
            <div className="col-12 md:col-3">
              <label className="field-label">Date</label>
              <input
                type="date"
                className="clean-input"
                value={tempDateEvent}
                onChange={(e) => setTempDateEvent(e.target.value)}
              />
            </div>
            <div className="col-12 md:col-3">
              <label className="field-label" style={{ marginBottom: "9px" }}>
                Type de bar
              </label>
              <select
                className="clean-select mt-[5px]"
                value={tempTypeBar}
                onChange={(e) => setTempTypeBar(e.target.value)}
              >
                <option value="avec_alcool">Avec alcool</option>
                <option value="sans_alcool">Sans alcool</option>
                <option value="avec_alcool, sans_alcool">
                  Avec et sans alcool
                </option>
              </select>
            </div>
          </div>

          <div className="grid mb-3">
            <div className="col-12">
              <label className="field-label">Informations complémentaires</label>
              <textarea
                className="clean-textarea"
                value={tempMore}
                onChange={(e) => setTempMore(e.target.value)}
                rows={2}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
}